<template>
  <div class="container-fluid">
    <div class="heightcontainer">
      <landing-navbar></landing-navbar>
        <section class="section1 mt-2 pb-5 pt-5">
            <img src="../../assets/UpdatedLanding6.png" class="bgimg d-none d-md-block" alt="bg">
          <div class="container-fluid pt-5 pb-3 pb-md-0 pb-lg-5 d-md-flex containerfluidcontent">
            <div class="col-md-6 my-auto">
              <h1 class="font48-bold-main proximanova-bold mt-5">Discover <span id="titleChange" class="blue">Opportunities</span></h1>                     
              <p class="fontsize20 mt-3 mb-1 proximanova pointerIcon">Get inside a world of global opportunities with the help of a short video networking platform where you can connect with people, be seen and converse with top industry leaders and business owners from any part of the world.</p>            
              <div class="pb-3 mt-4 pb-5">
                <button class="btn p-2 mt-3 pl-4 pr-4 fontsize16 borderradius20 mouseoverbtn2 backgroundcolor3 proximanova-semibold white" @click="NavToUserSignUp">Get Started</button>
              </div>
              <span class="d-none d-lg-block">
              <div class="d-flex flex-column mt-md-5">
                <span class="fontsize16 proximanova-semibold black60">Supported by 3k+ companies</span>
                <div class="d-flex flex-wrap mt-4 col-10 p-0 justify-content-between">
                    <img src="../../assets/UpdatedLandingcomLogo1.png" class="img-fluid col-5 col-md-3 mt-2" alt="company1">
                    <img src="../../assets/UpdatedLandingcomLogo5.png" class="img-fluid col-5 col-md-3 mt-2" alt="company1">
                    <img src="../../assets/UpdatedLandingcomLogo3.png" class="img-fluid col-5 col-md-3 mt-2" alt="company1">
                    <img src="../../assets/UpdatedLandingcomLogo4.png"  class="img-fluid col-5 col-md-3 mt-2" alt="company1">
                </div>
              </div>
              </span>
            </div>
            <div class=" bordernone borderradius20 my-lg-auto col-md-6 mx-auto pl-0 pr-0 mt-md-4 mt-md-5 mt-lg-4 addbgimg">
              <div class="col-lg-9 mx-auto p-5 p-md-2">
                <img src="../../assets/UpdatedLanding1.png" class="img-fluid mt-4 mt-md-0 mt-lg-4" alt="career">
              </div>
            </div>
          </div>
          <span class="d-block d-lg-none">
            <div class="d-flex flex-column mt-3 p-3">
              <span class="fontsize16 proximanova-semibold black60">Supported by 3k+ companies</span>
                <div class="d-flex flex-wrap justify-content-around mt-2">
                    <img src="../../assets/UpdatedLandingcomLogo1.png" class="img-fluid col-5 col-md-3 mt-3" alt="company1">
                    <img src="../../assets/UpdatedLandingcomLogo5.png"  class="img-fluid col-5 col-md-3 mt-3" alt="company1">
                    <img src="../../assets/UpdatedLandingcomLogo3.png" class="img-fluid col-5 col-md-3 mt-3" alt="company1">
                    <img src="../../assets/UpdatedLandingcomLogo4.png" class="img-fluid col-5 col-md-3 mt-3" alt="company1">
                </div>
              </div>
          </span>
        </section>
        <section class="d-md-flex backgroundcolor14 p-4 justify-content-around">
            <div class="col-md-3 d-flex flex-column text-center p-4">
                <span class="proximanova-bold fontsize32 white">1K+</span>
                <span class="proximanova fontsize24 white">Ready Job Vacancy</span>
            </div>
            <div class="col-md-3 d-flex flex-column text-center p-4">
                <span class="proximanova-bold fontsize32 white">100K+</span>
                <span class="proximanova fontsize24 white">Job Seeker Active</span>
            </div>
            <div class="col-md-3 d-flex flex-column text-center p-4">
                <span class="proximanova-bold fontsize32 white">1K+</span>
                <span class="proximanova fontsize24 white">Incorporated Company</span>
            </div>
        </section>  
        <section class="container-fluid d-flex flex-column mx-auto text-center pt-5 pb-5 backgroundcolorgray1">
            <span class="proximanova-semibold fontsize36 black pt-5">Loved by professionals from around the world</span>
                <span class="proximanova fontsize20 black60">Select a platform to experience engagement, connections and conversations with a diverse population.</span>
                <div class="col-md-10 col-lg-6 mx-auto mt-4 pb-5 d-flex flex-wrap justify-content-around">
                    <img src="../../assets/UpdatedLandingcomLogo1.png" class="col-5 col-md-3 col-lg-2 pl-lg-0 pr-lg-0 mt-3" alt="company1">
                    <img src="../../assets/UpdatedLandingcomLogo5.png" class="col-5 col-md-3 col-lg-2 pl-lg-0 pr-lg-0 mt-3" alt="company1">
                    <img src="../../assets/UpdatedLandingcomLogo3.png" class="col-5 col-md-3 col-lg-2 pl-lg-0 pr-lg-0 mt-3" alt="company1">
                    <img src="../../assets/UpdatedLandingcomLogo4.png" class="col-5 col-md-3 col-lg-2 pl-lg-0 pr-lg-0 mt-3" alt="company1">
                </div>
                <!-- <div class="col-12 col-md-10 col-lg-6 mx-auto mt-4 myvideosection d-flex p-2 pb-3">
                  <span class="fontsize16 black80 proximanova pillbtn mr-2 mr-lg-3 p-1" :class="{'activeVideoSub':activeVideoClass == 'all'}"
                    id="all" @click="changePillBtnColour('all')">All</span>
                  <span class="fontsize16 black80 proximanova pillbtn mr-2 mr-lg-3 p-1" :class="{'activeVideoSub':activeVideoClass == 'it'}"
                    id="it" @click="changePillBtnColour('it')">IT Services</span>
                  <span class="fontsize16 black80 proximanova pillbtn mr-2 mr-lg-3 p-1" :class="{'activeVideoSub':activeVideoClass == 'tech'}"
                    id="tech" @click="changePillBtnColour('tech')">Technology</span>
                  <span class="fontsize16 black80 proximanova pillbtn mr-2 mr-lg-3 p-1" :class="{'activeVideoSub':activeVideoClass == 'health'}"
                    id="health" @click="changePillBtnColour('health')">Healthcare & Life Sciences</span>
                  <span class="fontsize16 black80 proximanova mr-2 mr-lg-3 p-1" id="draft_tab">+5 more</span>
                </div>-->
                <div class="d-flex flex-wrap justify-content-around mt-4 col-lg-10 mx-auto" v-if="usersList.length > 0">
                  <div class="jobscard card borderradius20 shadow mt-2"  v-for="(user, index) in usersList" :key="index">
                    <div class="p-3 p-lg-4">
                      <div class="d-flex justify-content-between">
                        <img v-if="user.profilePictureLink" @error="user.profilePictureLink=null" :src="user.profilePictureLink" width="70px" height="70px" class="borderradiushalf" alt="pic">
                        <!-- <img v-else src="../../assets/UpdatedLandinguser.png" alt="user"> -->
                        <div v-else id="profImage1" class=" text-center mt-0 mt-md-2 pointer rounded-circle white" :class="user.userFullName.charAt(0)">
                            <span class="white fontsize24 text-uppercase">{{user.userFullName.charAt(0)}}</span>
                          </div>
                        <div class="backgroundcolor15 width100 pointer fontsize14 btnheight30 my-auto borderradius20 p-2 text-center fontsize18 proximanova-semibold blue" @click="NavToSelectedUser(user)">
                          <span >Follow</span>
                        </div>
                      </div>
                      <div class="d-flex text-left flex-column mt-2">
                        <span class="fontsize20 proximanova-semibold black">{{user.userFullName}} <img src="../../assets/verify_blue.svg" class="" alt="verify" width="20px" title="Verified" v-if="user.verifiedByAdmin == 'SUCCESS'"> </span>
                        <span v-if="user.userName" class="proximanova fontsize12 blue pointer" @click="NavToSelectedUser(user)">@{{user.userName}}</span>
                        <span class="fontsize12 proximanova black60">{{user.companyName}} | {{user.designation}} | {{user.location}}</span>
                        <span class="fontsize12 proximanova black60 mt-2" v-if="user.aboutYou">{{user.aboutYou}}</span>
                        <span class="fontsize14 proximanova black60 mt-2" v-else>Seeking a position to utilize my skills and experience for implementing the...</span>
                        <div class="col-12 pl-0 pr-0 d-flex flex-wrap" v-if="user.badges">
                          <span v-for="(badge, ind) in user.badges" :key="ind">
                          <span class="fontsize12 black80 proximanova pillbtn mr-2 mr-lg-3 p-1 mt-2">{{badge}}</span>
                          </span>
                          <!-- <span class="fontsize12 black80 proximanova pillbtn mr-2 mr-lg-3 p-1 mt-2">AWS</span>
                          <span class="fontsize12 black80 proximanova pillbtn mr-2 mr-lg-3 p-1 mt-2">SEO Optimization</span> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="d-md-flex mt-4 col-lg-10 mx-auto" v-if="usersList.length > 0">
                  <div class="col-md-4 mt-2" v-for="(user, index) in usersList" :key="index">
                    <div class="card shadow borderradius20 p-3 p-lg-4">
                      <div class="d-flex justify-content-between">
                        <img v-if="user.profilePictureLink" :src="user.profilePictureLink" class="img-fluid borderradiushalf" alt="pic">
                        <img v-else src="../../assets/UpdatedLandinguser.png" alt="user">
                        <div class="backgroundcolor15 width100 fontsize14 btnheight30 my-auto borderradius20 p-2 text-center fontsize18 proximanova-semibold blue">
                          <span >Follow</span>
                        </div>
                      </div>
                      <div class="d-flex text-left flex-column mt-2">
                        <span class="fontsize20 proximanova-semibold black">{{user.userFullName}}</span>
                        <span class="fontsize12 proximanova black60">{{user.companyName}} | {{user.designation}}</span>
                        <span class="fontsize12 proximanova black60">{{user.location}}</span>
                        <span class="fontsize14 proximanova black60 mt-2" v-if="user.aboutYou">{{user.aboutYou.substr(0,60)}}...</span>
                        <span class="fontsize14 proximanova black60 mt-2" v-else>Seeking a position to utilize my skills and experience for implementing the...</span>
                        <div class="col-12 pl-0 pr-0 d-flex flex-wrap" v-if="user.badges">
                          <span v-for="(badge, ind) in user.badges" :key="ind">
                          <span class="fontsize12 black80 proximanova pillbtn mr-2 mr-lg-3 p-1 mt-2">{{badge}}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>  -->
        </section>
        <section class="container-fluid d-flex flex-column mx-auto text-center pt-5 pb-5 backgroundcolorwhite" v-if="jobsList.length>0">
            <span class="proximanova-semibold fontsize36 black">Featured Companies are actively hiring</span>
                <span class="proximanova fontsize20 black60">Choose a relevant job from the list of jobs below.</span>
                <div class="d-flex flex-wrap justify-content-around mt-4 col-lg-10 mx-auto">
                  <div class="jobscard card borderradius20 shadow mt-2" v-for="(job, index) in jobsList" :key="index">
                    <div class="col-12 p-3 p-lg-4">
                      <div class="mx-auto">
                        <img :src="job.companyLogoLink" class="img-fluid borderradiushalf" width="80px" alt="user">
                      </div>
                      <div class="borderradius20 mt-3 p-2 d-flex flex-column backgroundcolor9">
                        <span class="fontsize16 proximanova-semibold black">{{job.titleName}}</span>
                        <span class="fontsize12 proximanova black60">{{job.companyName}} | {{job.cityName}}</span>
                      </div>
                      <span class="fontsize14 proximanova black60 mt-4">We provide onsite and offshore professional services for software solutions.</span>
                      <div class="backgroundcolor15 width100 fontsize14 pointer mt-3 btnheight30 mx-auto borderradius20 p-2 text-center fontsize18 proximanova-semibold blue" v-if="job.jobAliasId" @click="navToSelectedJobDetails(job)">
                        <span >More Details</span>
                      </div>
                    </div>
                  </div>
                </div>
        </section>  
        <section class="container-fluid d-flex flex-column mx-auto text-center pt-5 pb-5 backgroundcolorwhite">
            <span class="proximanova-semibold fontsize36 black p-1">Follow our Steps, We will <span class="blue">Help you</span> </span>
                <span class="proximanova fontsize20 black60 col-lg-8 mx-auto">Follow the steps below for a better understanding of how to find a job, get selected by your dream company and be valued by employers worldwide.</span>
                <div class="d-md-flex flex-wrap mt-4 col-lg-8 mx-auto">
                  <div class="card followstepscard shadow borderradius20 mt-2 mx-auto">
                    <div class=" p-3 p-lg-4">
                      <div class="d-flex text-center flex-column mt-2">
                        <span class="fontsize20 proximanova-semibold black">Register your <span class="blue">account</span> </span>
                        <span class="fontsize14 proximanova black60 mt-3 pl-lg-3 pr-lg-3 mx-auto">Get access to a range of jobs by registering an account on our platform.</span>
                        <div class="d-flex flex-column mt-5">
                          <div class="col-10 backgroundcolor16 borderradius5 proximanova white p-2">First Name</div>
                          <span>
                          <div class="col-10 pull-right backgroundcolor3 borderradius5 proximanova white p-2 mt-3">Last Name</div></span>
                          <div class="col-10 backgroundcolor17 borderradius5 proximanova white p-2 mt-3">Email</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card followstepscard shadow borderradius20  mt-2 mx-auto">
                    <div class="p-3 p-lg-4">
                      <div class="d-flex text-center flex-column mt-2">
                        <span class="fontsize20 proximanova-semibold black">Select your <span class="blue">Preference</span> </span>
                        <span class="fontsize14 proximanova black60 mt-3 pl-lg-1 pr-lg-1 mx-auto">Discover jobs, industries and companies that you are looking for by mentioning your Experience level, Current salary, location and job type.</span>
                        <span class="fontsize14 proximanova black60 mt-1 pl-lg-1 pr-lg-1 mx-auto">Help companies and recruiters get a clear representation of you.</span>
                        <div class="d-flex flex-column mt-4">
                          <div class="col-10 d-flex justify-content-around backgroundcolor16 mt-2 borderradius5 proximanova white p-2">
                            <div class="box borderradius20 white my-auto backgroundcolorwhite"></div>
                            <div class=" ml-1 my-auto">Syntrino</div>
                            <div class="ml-1 my-auto backgroundcolorwhite fontsize12 borderradius20 black pl-2 pr-2">Apply</div>
                          </div>
                          <span>
                            <div class="col-10 mt-3 pull-right d-flex justify-content-around backgroundcolor3 borderradius5 proximanova white p-2">
                              <div class="box borderradius20 white my-auto backgroundcolorwhite"></div>
                              <div class=" ml-1 my-auto">Apple</div>
                              <div class="ml-1 my-auto backgroundcolorwhite fontsize12 borderradius20 black pl-2 pr-2">Apply</div>
                            </div>
                          </span>
                          <div class="col-10 mt-3 d-flex justify-content-around backgroundcolor17 borderradius5 proximanova white p-2">
                            <div class="box borderradius20 white my-auto backgroundcolorwhite"></div>
                            <div class=" ml-1 my-auto">Careertuner</div>
                            <div class="ml-1 my-auto backgroundcolorwhite fontsize12 borderradius20 black pl-2 pr-2">Apply</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card followstepscard shadow borderradius20 mt-2 mx-auto">
                    <div class="pt-3 pl-3 pr-3 pb-0 pt-lg-4 pl-lg-4 pr-lg-4">
                      <div class="d-flex text-center flex-column mt-2">
                        <span class="fontsize20 proximanova-semibold black">Apply and <span class="blue">track the job</span> </span>
                        <span class="fontsize14 proximanova black60 mt-3 pl-lg-3 pr-lg-3 mx-auto">Apply to a diverse range of jobs and communicate with employers globally in one place.</span>
                        <div class="col-9 mx-auto mt-4"><img src="../../assets/stepbar.svg" class="img-fluid" alt="step"></div>
                      </div>
                    </div>
                  </div>
                </div>
        </section>
        <section class="container-fluid d-md-flex pt-5 pb-5 backgroundcolorwhite">
            <div class="col-md-6 col-lg-7 my-auto p-lg-5">
                <div class="d-flex p-lg-4 flex-column ml-lg-5">
                    <!-- <div class="backgroundcolor15 width200 borderradius20 p-2 text-center fontsize18 proximanova-semibold blue">
                        <span >Our Services</span>
                    </div> -->
                    <div class="d-flex flex-column mt-lg-3">
                        <span class="fontsize32 proximanova-bold black">Find a job based  on </span>
                        <span class="fontsize32 proximanova-bold black">your <span class="blue">experience</span> </span>
                        <span class="fontsize16 proximanova black mt-2 mt-lg-4">Demonstrate your previous and current experiences in a job role, field or industry. Based on that, we will help you match with relevant jobs and help you navigate your job searching journey easily.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-5 my-auto pr-3 pr-md-0">
                <img src="../../assets/UpdatedLanding2.png" class="img-fluid mt-4 mt-md-0" alt="">
            </div>
        </section>  
        <section class="container-fluid d-md-flex pt-md-5 pt-lg-0 pb-5 backgroundcolorwhite">
            <div class="d-none d-md-block col-md-6 col-lg-5 my-auto pl-0">
                <img src="../../assets/UpdatedLanding3.png" class="img-fluid" alt="">
            </div>
            <div class="col-md-6 col-lg-7 my-auto p-lg-5">
                <div class="d-flex p-lg-4 flex-column ml-lg-5">
                    <!-- <div class="backgroundcolor15 width200 borderradius20 p-2 text-center fontsize18 proximanova-semibold blue">
                        <span >Our Services</span>
                    </div> -->
                    <div class="d-flex flex-column mt-lg-3">
                        <span class="fontsize32 proximanova-bold black">Get notified about progress of profile and <span class="blue">application tracking </span></span>
                        <span class="fontsize16 proximanova black mt-2 mt-lg-4">You will be able to check who visited your profile, receive regular updates and track your application's status on our platform that gives you a sense of control and authority.</span>
                    </div>
                </div>
            </div>
            <div class="d-block d-md-none col-md-6 col-lg-5 mt-2">
                <img src="../../assets/UpdatedLanding3.png" class="img-fluid" alt="">
            </div>
        </section>  
        <section class="container-fluid d-md-flex pt-md-5 pt-lg-0 pb-5 backgroundcolorwhite">
            <div class="col-md-6 col-lg-7 my-auto p-lg-5">
                <div class="d-flex p-lg-4 flex-column ml-lg-5">
                    <!-- <div class="backgroundcolor15 width200 borderradius20 p-2 text-center fontsize18 proximanova-semibold blue">
                        <span >Our Services</span>
                    </div> -->
                    <div class="d-flex flex-column mt-lg-3">
                        <span class="fontsize32 proximanova-bold black">start with screening questions posted by <span class="blue">hiring managers</span></span>
                        <span class="fontsize16 proximanova black mt-2 mt-lg-4">Answer the screening questions posted by hiring managers that will help you get to know the job role requirements better and then go for the next step towards the interview.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-5 my-auto pr-3 pr-md-0">
                <img src="../../assets/UpdatedLanding4.png" class="img-fluid" alt="">
            </div>
        </section>
        <section class="section3 backgroundcolorblack pt-5 pb-5 pl-3 pr-3 pl-md-5 pr-md-5 pr-lg-0">
          <div class="container-fluid pt-5 pb-5 d-md-flex containerfluidcontent">
            <div class="col-lg-12">
              <div class="vertical-center text-center pl-md-3 pr-md-3">   
                <h2 class="font48-bold-main white proximanova-bold">Ready for the big change?</h2>
                <h2 class="font48-bold-main white proximanova-bold"> Let’s connect!</h2>                       
              </div>
              <div class="pb-3 pl-md-3 pr-md-3 mt-4 text-center">
                <button class="btn fontsize18 signupbtnstyles p-2 mt-3 pl-5 pr-5 borderradius20 newbtnstyles backgroundcolor3 proximanova-semibold white" @click="NavToSignup">Sign Up</button>
              </div>
            </div>
          </div>
        </section> 
    </div>    
    <Footer class="footer" ></Footer>
  </div> 
</template>
<script>
import BottomFooter from "@/components/BottomFooter.vue";
import Footer from '../LandingFooter.vue'
import router from '../../router.js'
import LandingNavbar from './Navbar.vue'
import wndata from '../../js/wn_data.json'
import httppostjob from "@/js/http-postjob.js"
import $ from 'jquery'
export default {
  components: {
    BottomFooter,   
    Footer,
    LandingNavbar
  },
  data() {
    return {
      activeVideoClass : 'all',
      usersList : [],
      jobsList :  [],
    };
  },
  methods: {
     animatedSection1(){
      console.log("check")
            var title = document.getElementById('titleChange')
            var titles = [
              {text : 'Opportunities'},
              {text : 'People'},
              {text : "Company"}
            ]
            var i = 0;
            setInterval(function() {
              title.innerHTML = titles[i].text;
              i = i + 1;
                if (i == titles.length) {
                    i =  0;
                }
            }, 2000);
        },
    NavToSignup() {
      router.push({
        name : 'signup'
      })
    },
    NavToUserSignUp() {
      router.push({
        name : 'signup'
      })
    },
    changePillBtnColour : function(status) {
      this.activeVideoClass = status;
    },
    fetchJobsList() {
      httppostjob.get('postjob/getJobsforLandingPage')
      .then((response) => {
        console.log("landing page posted jobs : ", response.data)
        this.jobsList = response.data;
      }).catch((e) => {
        console.log(e.response)
      })
    },
    fetchuserList() {
      httppostjob.get('postjob/getCompaniesProfessionalData')
      .then((response) => {
        console.log("landing page users list : ", response.data)
        this.usersList = response.data;
      }).catch((e) => {
        console.log(e.response)
      })
    },
    navToSelectedJobDetails(job){
      router.push({
        name : 'viewjob', params : {id : job.jobAliasId}
      })
    },
    NavToSelectedUser(user){
      router.push({
        name : 'wn', params : {id : user.userName}
      })
    }
  },
  mounted: function() {
    window.scrollTo(0, 0)
    this.animatedSection1()
    this.fetchJobsList()
    this.fetchuserList()
  },
  computed: {
    isDisabled: function() {
      return !this.terms;
    }
  }
};
</script>
<style scoped>
.bgimg{
    position: absolute;
    z-index: 1;
    margin-right: -6%;
    margin-top: -20%;
    top: 0;
    right: 0;
}
.section1{
    position: relative;
    z-index: 2;
    overflow: hidden;
}
.containerfluidcontent{
    position: relative;
    z-index: 2;
}
.button-create{
  font-size: 14px !important;
}
.button-create:focus {
  outline: 0 !important;
}
#profImage1{
  width: 70px;
  height: 70px;
  line-height: 70px;
}
.signupbtnstyles{
  width: 300px;
  height: 75px;
  font-size: 24px;
  border-radius: 40px !important;
  z-index: 3;
}
.videocard{
  background: black;
  border-radius: 20px;
  padding: 25px 0;
}
.myvideosection {
  overflow: auto;
  white-space: nowrap;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.followstepscard{
  width: calc(33.33333% - 1.11111rem) !important;
}
.jobscard{
  width: calc(24.33333% - 1.11111rem) !important;
}
.myvideosection span{
  display: inline-block;
  text-align: center;
  /* padding: 14px; */
  text-decoration: none;
}
.myvideosection::-webkit-scrollbar {
  display: none;
}
.pillbtn {
  cursor: pointer;
  border: 1px solid #dbdbdb;
  border-radius: 16px;
  height: 30px;
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.activeVideoSub {
  background-color: #d6e9ff;
  border: 1px solid #9ecbff;
  color: #0078ff;
}
.pillbtn:hover {
  background-color: rgba(161, 166, 179,0.1);
  border: 1px solid rgba(161, 166, 179,.5);
  /* font-weight: bold; */
}
#videoTag{
  width: 100%;
  /* background-image: linear-gradient(rgba(31, 31, 31, .1), rgba(31,31,31,.1)), url(''); */
}
.landingElementStyles{
  width: 150px;
  position: absolute;
  margin-top: -90px;
  z-index: 1;
}
.zindex1{
  z-index: 1 !important;
}
.zindex2{
  z-index: 2 !important;
}
.gradientColor1{
  /* background: -webkit-linear-gradient(rgb(27, 140, 233), rgb(147, 209, 209), rgb(2, 61, 61)) !important;
  -webkit-background-clip: text !important; */
  -webkit-text-fill-color: transparent !important;
  background: -webkit-linear-gradient(left, yellow , red);
   background: -o-linear-gradient(right, yellow , red);
   background: -moz-linear-gradient(right, yellow , red);
   background: linear-gradient(to right, yellow , red); 
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.gradientColor2{
  background: -webkit-linear-gradient(#12c2e9, #c471ed, #f7797d) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}
.gradientColor3{
  background: -webkit-linear-gradient(rgb(182, 44, 20), rgb(209, 203, 147), rgb(63, 175, 12)) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}
#playvideobtn{
  margin-top: 60px !important;
}
.pausebtn{
  display: none;
  margin-top: 60px !important;
  margin-left: 44% !important;
}
.videocard:hover .pausebtn{
  display: block;
  margin-top: 75px !important;
}
.section2bacgImg{
  z-index: 1;
  position: absolute;
  margin-top: 30%;
  left: 0;
  margin-left: 40px !important;
}
.section2frontimg{
  z-index: 2;
  position: relative;
}
.section7bacgImg{
  z-index: 1;
  position: absolute;
  left: 0;
  margin-left: 10px !important;
}
.newbtnstyles {
	transition : ease-out 0.3s;
	  POSITION : relative;
	  z-index : 1;
  }
  .newbtnstyles::before{
	transition : 0.5s all ease;
	  position : absolute;
	  top : 0;
	  left : 30%;
	  right : 30%;
	  bottom : 0;
	  opacity : 0;
	  content : "";
	border-radius: 40px;
	margin-top: 0px;
	  background-color :  rgba(255, 255, 255, .35);
  }
  .newbtnstyles:hover::before{
	transition : 0.5s all ease;
	  left : 0;
	  right : 0;
	  opacity : 1;
	  z-index : -1
  }
@media (min-width: 992px){
  .containerfluidcontent{
    width: 90% !important;
  }
  .whatpeoplesayCard{
    position: absolute;
    z-index: 2;
    margin-top: 8%;
  }
  #videoTag{
    height: 460px !important;
  }
  #playvideobtn{
    margin-top: 200px !important;
  }
  .pausebtn{
    display: none;
    margin-top: 220px !important;
    margin-left: 48% !important;
  }
  .videocard:hover .pausebtn{
    display: block;
    margin-top: 215px !important;
  }
}
section {
 margin: 0 0 0rem 0rem  !important ;
}
.footer {
  background-color: #F0F0F0;       
  color : white;
  position: sticky;
}
.top-padding{
  padding-top:3rem !important;
}
h2{
  font-weight: 300;
}
.section1 {
  background-color:white;
}
.section2 {
  background-color:white;
}   
@media screen and (min-width: 300px) and (max-width: 350px) {
  .top-padding{
    padding-top:0rem !important;
  }
  .font24-reg-main{
    font-size: 16px;
  }
  .font48-bold-main {	
    font-size: 24px;	
  }
  .font40-bold-main{
    font-size: 20px;
  }
}
@media screen and (min-width: 350px) and (max-width: 400px) {
  .top-padding{
    padding-top:0rem !important;
  }
  .font24-reg-main{
    font-size: 16px;
  }
  .font48-bold-main {	
    font-size: 24px;	
  }
  .font40-bold-main{
    font-size: 20px;
  }
}
@media screen and (min-width: 300px) and (max-width: 600px) {
  .section1content{
    margin-top: 12% !important;
  }
  .top-padding{
    padding-top:0rem !important;
  }
  .signupbtnstyles{
    width: 200px;
    height: 50px;
    font-size: 20px;
    border-radius: 40px !important;
  }
  .followstepscard{
    width: calc(98.33333% - 1.11111rem) !important;
  }
  .jobscard{
    width: calc(98.33333% - 1.11111rem) !important;
  }
  .addbgimg{
  background-image: url('../../assets/UpdatedLanding6.png');
  background-size: cover !important;
    -webkit-background-size: cover !important;
}
}
@media screen and (min-width: 600px) and (max-width: 800px) {
  .section1content{
    margin-top: 12% !important;
  }
  #playvideobtn{
    margin-top: 160px !important;
  }
  .pausebtn{
    display: none;
    margin-top: 160px !important;
    margin-left: 46% !important;
  }
  .videocard:hover .pausebtn{
    display: block;
    margin-top: 175px !important;
  }
  .signupbtnstyles{
    width: 200px;
    height: 50px;
    font-size: 20px;
    border-radius: 40px !important;
  }
  .followstepscard{
    width: calc(49.33333% - 1.11111rem) !important;
  }
  .jobscard{
    width: calc(49.33333% - 1.11111rem) !important;
  }
}
@media screen and (min-width: 400px) and (max-width: 600px) {
  .top-padding{
    padding-top:0rem !important;
  }
  .font48-bold-main {	
    font-size: 28px;	
  }
  .font40-bold-main{
    font-size: 24px;
  }
  .font24-reg-main {
    font-size: 18px;
  }
  .bgimg{
    width: 100%;
        position: absolute;
        z-index: 1;
        margin-right: 0%;
        margin-top: 130%;
        top: 0;
        right: 0;
    }
    .followstepscard{
    width: calc(98.33333% - 1.11111rem) !important;
  }
  .jobscard{
    width: calc(98.33333% - 1.11111rem) !important;
  }
}
@media screen and (max-width: 900px) and (min-width: 800px) {
  .top-padding{
    padding-top:0rem !important;
  }
}
@media screen and (max-width: 700px) and (min-width: 600px) {
  .top-padding{
    padding-top:0rem !important;
  }
}
@media screen and (max-width: 800px) and (min-width: 700px) {
  .top-padding{
    padding-top:0rem !important;
  }
}
@media screen and (max-width: 800px) and (min-width: 600px) {
    .bgimg{
    width: 100%;
        position: absolute;
        z-index: 1;
        margin-right: -30%;
        top: 0;
        right: 0;
    }
}
@media screen and (min-width:1600px) {
  .bgimg{
    position: absolute;
    z-index: 1;
    margin-right: 2%;
    margin-top: -5%;
    top: 0;
    right: 0;
  }
  .col-lg-10{
    -webkit-box-flex: 0;
    flex: 0 0 70.333333%;
    max-width: 70.333333%;
  }
}

</style>
